class FreeShippingProgress {
  constructor() {
    this.cartUpdateUnsubscriber = null;
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.handleSectionLoad = this.handleSectionLoad.bind(this);

    this.init();
  }

  init() {
    this.updateAll();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
    }

    document.addEventListener('shopify:section:load', this.handleSectionLoad);
  }

  handleCartUpdate(event = {}) {
    const cartTotalCents = event.cartData?.total_price;
    if (Number.isFinite(cartTotalCents)) {
      this.updateAll(cartTotalCents);
    } else {
      // cart/add.js returns the line item, not the full cart — fetch fresh totals
      fetch(window.Shopify?.routes?.root + 'cart.js')
        .then((r) => r.json())
        .then((cart) => this.updateAll(cart.total_price))
        .catch(() => this.updateAll());
    }
  }

  handleSectionLoad() {
    this.updateAll();
  }

  updateAll(cartTotalCents) {
    document.querySelectorAll('[data-free-shipping-progress]').forEach((el) => {
      this.updateProgressElement(el, cartTotalCents);
    });
  }

  updateProgressElement(progressElement, cartTotalCents) {
    const thresholdCents = Number(progressElement.dataset.thresholdCents) || 0;
    if (thresholdCents <= 0) return;

    const fallbackTotalCents = Number(progressElement.dataset.cartTotalCents) || 0;
    const currentTotalCents = Number.isFinite(cartTotalCents) ? cartTotalCents : fallbackTotalCents;
    const remainingCents = Math.max(thresholdCents - currentTotalCents, 0);
    const progressPercentage = Math.min((currentTotalCents / thresholdCents) * 100, 100);

    const messageElement = progressElement.querySelector('[data-free-shipping-message]');
    const progressFillElement = progressElement.querySelector('[data-free-shipping-fill]');
    const unlockedMessage = this.decodeHtmlEntities(progressElement.dataset.unlockedMessage || '');
    const remainingTemplate = this.decodeHtmlEntities(progressElement.dataset.remainingTemplate || '');

    if (messageElement) {
      const newText = remainingCents > 0
        ? remainingTemplate.replace('[amount]', this.formatMoney(remainingCents, progressElement))
        : unlockedMessage;

      if (messageElement.textContent !== newText) {
        messageElement.classList.add('cart-free-shipping__message--updating');
        requestAnimationFrame(() => {
          messageElement.textContent = newText;
          messageElement.classList.remove('cart-free-shipping__message--updating');
          messageElement.classList.add('cart-free-shipping__message--updated');
          setTimeout(() => messageElement.classList.remove('cart-free-shipping__message--updated'), 400);
        });
      }
    }

    if (progressFillElement) {
      progressFillElement.style.width = `${progressPercentage}%`;
    }

    progressElement.querySelector('.cart-free-shipping__progress')?.setAttribute('aria-valuenow', Math.round(progressPercentage));
    progressElement.dataset.cartTotalCents = String(currentTotalCents);
  }

  formatMoney(cents, progressElement) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, progressElement.dataset.moneyFormat);
    }

    const currencyCode = window.Shopify?.currency?.active || 'EUR';
    const localeCode = document.documentElement.lang || undefined;
    const amount = cents / 100;

    try {
      return new Intl.NumberFormat(localeCode, {
        style: 'currency',
        currency: currencyCode,
      }).format(amount);
    } catch (error) {
      console.warn('Free shipping money formatting failed', error);
      return amount.toFixed(2);
    }
  }

  decodeHtmlEntities(value) {
    const parserElement = document.createElement('textarea');
    parserElement.innerHTML = value;
    return parserElement.value;
  }
}

if (!window.__freeShippingProgressInitialized) {
  window.__freeShippingProgressInitialized = true;
  new FreeShippingProgress();
}
